import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Understanding Business Capital: A Complete Guide",
      excerpt: "Learn about different types of business capital, how to assess your needs, and prepare for funding opportunities.",
      date: "December 1, 2024",
      category: "Funding Basics",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=400&fit=crop",
      slug: "understanding-business-capital"
    },
    {
      id: 2,
      title: "5 Steps to Prepare Your Business for Funding",
      excerpt: "Essential steps every business owner should take before seeking capital, from documentation to financial planning.",
      date: "November 28, 2024",
      category: "Preparation",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop",
      slug: "preparing-for-funding"
    },
    {
      id: 3,
      title: "How to Choose the Right Lender for Your Business",
      excerpt: "Navigate the lending landscape with confidence. Learn how to evaluate lenders and find the best fit for your needs.",
      date: "November 25, 2024",
      category: "Lender Selection",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=400&fit=crop",
      slug: "choosing-right-lender"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Blog - Business Capital Insights | Miranda Landa Services LLC</title>
        <meta name="description" content="Expert insights on business capital, funding preparation, and financial strategy from Miranda Landa Services LLC." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            Business Capital Insights
          </h1>
          <p style={{fontSize: '1.2rem', opacity: 0.95}}>
            Expert guidance on funding, financial strategy, and business growth
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '2rem'
          }}>
            {blogPosts.map((post) => (
              <article key={post.id} className="card" style={{overflow: 'hidden', padding: 0}}>
                <img 
                  src={post.image} 
                  alt={post.title}
                  style={{width: '100%', height: '200px', objectFit: 'cover'}}
                />
                <div style={{padding: '2rem'}}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1rem'
                  }}>
                    <span style={{
                      background: '#f0fdf4',
                      color: '#059669',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '20px',
                      fontSize: '0.85rem',
                      fontWeight: '600'
                    }}>
                      {post.category}
                    </span>
                    <span style={{color: '#6b7280', fontSize: '0.9rem'}}>
                      {post.date}
                    </span>
                  </div>
                  <h2 style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#064e3b',
                    marginBottom: '1rem'
                  }}>
                    {post.title}
                  </h2>
                  <p style={{color: '#6b7280', lineHeight: '1.6', marginBottom: '1.5rem'}}>
                    {post.excerpt}
                  </p>
                  <Link 
                    to={`/blog/${post.slug}`}
                    style={{
                      color: '#059669',
                      fontWeight: '600',
                      textDecoration: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}
                  >
                    Read More →
                  </Link>
                </div>
              </article>
            ))}
          </div>

          <div style={{
            marginTop: '4rem',
            textAlign: 'center',
            background: '#f0fdf4',
            padding: '3rem 2rem',
            borderRadius: '12px'
          }}>
            <h3 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              Ready to Explore Your Funding Options?
            </h3>
            <p style={{color: '#065f46', marginBottom: '2rem', fontSize: '1.1rem'}}>
              Schedule a consultation with our expert team
            </p>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
              color: 'white',
              padding: '1rem 2.5rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.1rem',
              display: 'inline-block'
            }}>
              Get Started
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
